import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from '~shared/FluidImage'

export default function Tuomas() {
    const data = useStaticQuery(graphql`
        {
            file(relativePath: { eq: "About/Team/Picture/Tuomas.jpg" }) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE, layout: CONSTRAINED)
                }
            }
        }
    `).file.childImageSharp.gatsbyImageData

    return <Img data={data} />
}
